import omitBy from 'lodash/omitBy'
import cloneDeep from 'lodash/cloneDeep'

// Remove undefined values from an object
export default function compactObject(obj: any) {
  return cloneDeep(omitBy(obj, value => typeof value === 'undefined'))
}
